export const SITE_URL = 'https://www.urbanshinelaundry.com';
export const SITE_NAME = 'Urban Shine Laundry';
export const TWITTER_HANDLE = '@urbanshinelaundry';

export const BUSINESS = {
    name: 'Urban Shine Laundry',
    legalName: 'Urban Shine Laundry',
    url: SITE_URL,
    logo: `${SITE_URL}/logo512.png`,
    image: `${SITE_URL}/og-image.jpg`,
    description:
        'Urban Shine Laundry offers professional dry cleaning, steam ironing, wash & fold, carpet cleaning, shoe cleaning, and leather cleaning with free home pickup and delivery in New Town, Kolkata.',
    telephone: '+918450903882',
    email: 'urbanshinelaundry46@gmail.com',
    address: {
        streetAddress: 'DF 05, Street Number 316, DF Block',
        addressLocality: 'New Town',
        addressRegion: 'West Bengal',
        postalCode: '700156',
        addressCountry: 'IN',
    },
    geo: {
        latitude: '22.5958',
        longitude: '88.4799',
    },
    openingHours: [
        'Mo 09:00-19:30',
        'Tu 09:00-19:30',
        'Th 09:00-19:30',
        'Fr 09:00-19:30',
        'Sa 09:00-19:30',
        'Su 09:00-19:30',
    ],
    priceRange: '₹₹',
    servesCuisine: null,
    hasMap: 'https://maps.app.goo.gl/wzb5BiWEBuxwm2c86',
    sameAs: [
        'https://www.facebook.com/urbanshinelaundry',
        'https://wa.me/918450903882',
        'https://maps.app.goo.gl/wzb5BiWEBuxwm2c86',
    ],
    aggregateRating: {
        ratingValue: '4.9',
        reviewCount: '40',
        bestRating: '5',
        worstRating: '1',
    },
    serviceArea: {
        type: 'GeoCircle',
        geoMidpoint: { latitude: 22.5958, longitude: 88.4799 },
        geoRadius: '10000',
    },
};

export const DEFAULT_SEO = {
    title: 'Urban Shine Laundry | Professional Laundry & Dry Cleaning in New Town, Kolkata',
    description:
        'Urban Shine Laundry offers professional dry cleaning, steam ironing, wash & fold, and more with free home pickup & delivery in New Town, Kolkata. Book online now!',
    keywords:
        'laundry service New Town Kolkata, dry cleaning Kolkata, steam ironing New Town, wash and fold Kolkata, laundry pickup delivery Kolkata, carpet cleaning Kolkata, shoe cleaning Kolkata, leather cleaning Kolkata, professional laundry Kolkata, Urban Shine Laundry, Action Area laundry, DF Block laundry service',
    ogImage: `${SITE_URL}/og-image.jpg`,
};
